import React from 'react';
import Box from '@material-ui/core/Box';
//import { PageBreadcrumbs, PageHeader } from '../index';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';
import Grow from '@material-ui/core/Grow';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import FadeWithDirection from '../../../../@coremat/CmtTransitions/FadeWithDirection';

const useStyles = makeStyles(() => ({
  pageFull: {
    width: '100%',
  },
}));

const PageContainer = ({ heading, breadcrumbs, children, className, restProps }) => {
  const classes = useStyles();
  //  {(heading || breadcrumbs) && (
  //   <PageHeader heading={heading} breadcrumbComponent={breadcrumbs && <PageBreadcrumbs items={breadcrumbs} />} />
  //         )}
  return (
    <Fade in={true} direction="up" mountOnEnter unmountOnExit>
      <Box className={clsx(classes.pageFull, className)} {...restProps}>
        {children}
      </Box>
    </Fade>
  );
};

export default PageContainer;
